(function () {
  /*
   * rb-crawler-v1 — identify search / AI crawlers so interstitials can stand down.
   *
   * Must run before rb-desktop-scale.js and the age gate, so it is loaded
   * render-blocking in <head>. Sets window.rbIsCrawler once; everything else
   * reads the flag rather than re-sniffing the user agent.
   *
   * Only affects automated clients. A human visitor never matches, so the
   * 21+ gate still stands in front of every real shopper.
   */

  /* Search + AI/LLM crawlers, social unfurlers, and SEO/audit tooling. */
  var CRAWLER_UA = new RegExp(
    [
      /* generic tokens used by the long tail of well-behaved crawlers */
      'bot\\b', 'bot[/;)_ -]', 'crawl', 'spider', 'scraper', 'fetcher', 'archiver',
      /* AI / LLM */
      'gptbot', 'chatgpt', 'oai-searchbot', 'openai',
      'claude', 'anthropic', 'perplexity', 'youbot', 'cohere',
      'google-extended', 'googleother', 'gemini', 'ccbot', 'diffbot',
      'bytespider', 'amazonbot', 'applebot', 'meta-externalagent',
      'timpibot', 'omgili', 'webzio', 'imagesift', 'awario', 'peer39',
      /* search engines */
      'googlebot', 'storebot-google', 'adsbot', 'mediapartners',
      'bingbot', 'bingpreview', 'msnbot', 'duckduck', 'yandex', 'baidu',
      'slurp', 'petalbot', 'seznam', 'qwant', 'exabot', 'sogou', 'naver',
      /* unfurlers — brand names must stay bot-qualified. Bare 'linkedin', 'pinterest',
         'telegram', 'whatsapp' and 'discord' also match those apps' in-app browsers, which
         are real shoppers, and skipping the gate for them is an age-verification failure.
         The generic 'bot\b' above already catches LinkedInBot, Pinterestbot, TelegramBot,
         Discordbot and Pinterest's own 'bot.html' crawler UA. */
      'facebookexternalhit', 'facebookcatalog', 'twitterbot',
      'slackbot', 'slack-imgproxy', 'redditbot', 'embedly',
      'quora link preview', 'skypeuripreview',
      /* audit / headless tooling */
      'lighthouse', 'pagespeed', 'chrome-lighthouse', 'gtmetrix', 'pingdom',
      'headlesschrome', 'phantomjs', 'prerender', 'screaming frog',
      'semrush', 'ahrefs', 'dataforseo', 'serpstat', 'moz\\.com', 'validator'
    ].join('|'),
    'i'
  );

  function detect() {
    var ua = '';
    try {
      ua = navigator.userAgent || '';
    } catch (err) {
      return false;
    }
    return CRAWLER_UA.test(ua);
  }

  function override() {
    /* ?rb_crawler=1 to preview crawler behaviour, ?rb_crawler=0 to force the gate */
    try {
      var value = new URLSearchParams(window.location.search).get('rb_crawler');
      if (value === '1' || value === 'true') return true;
      if (value === '0' || value === 'false') return false;
    } catch (err) {}
    return null;
  }

  /*
   * Consentmo is a Shopify app embed, so the theme cannot stop it loading — the
   * banner has to be taken out of the DOM once it mounts. Hiding it from a page
   * stylesheet does not work: <csm-cookie-consent> styles itself from an
   * important :host rule inside its shadow root, and shadow-tree important
   * declarations beat the outer document's.
   *
   * Only the banner element goes; window.Consentmo and its consent plumbing stay,
   * and the footer "Cookie settings" link is untouched for real visitors.
   */
  function stripConsentmo() {
    var SELECTOR = 'csm-cookie-consent, .csm-cmp-root';

    function sweep() {
      var found = document.querySelectorAll(SELECTOR);
      for (var i = 0; i < found.length; i += 1) found[i].remove();
    }

    sweep();

    /* The app injects late and re-renders, so watch instead of racing a timeout.
       Only added nodes are inspected — a full sweep per mutation would cost the
       crawler render budget this change is meant to protect. */
    try {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i += 1) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j += 1) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches(SELECTOR)) node.remove();
            else if (node.querySelector && node.querySelector(SELECTOR)) sweep();
          }
        }
      }).observe(document, { childList: true, subtree: true });
    } catch (err) {
      var ticks = 0;
      var timer = window.setInterval(function () {
        sweep();
        ticks += 1;
        if (ticks > 40) window.clearInterval(timer);
      }, 250);
    }
  }

  var forced = override();
  window.rbIsCrawler = forced === null ? detect() : forced;

  if (window.rbIsCrawler) {
    /* The Digioh tag is not requested for crawlers, so the 110px campaign-bar slot
       Liquid reserves on collection/product routes would stay empty. Drop it here,
       before first paint, rather than waiting on the reserve-release timeout. */
    document.documentElement.classList.remove('rb-digioh-reserve');
    stripConsentmo();
  }
})();
